import { Types } from "../../@types"
import React, { useEffect, useState } from "react"
import { Check, X } from "lucide-react"
import { appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import { ConditionalRow, useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"


/*
  There is one drop zone per conditional group.
  zones can be nested within each other.
  Each dropzone has a name value which is the parent of any group within it.

*/


export default function ConditionalDropZone({ className="", children }:{ className?:string; children?:React.ReactNode }){

  const { store, AppStore }:any = appStore()
  const { openModal, putItemInSpotlight, loadConditionalIntoZone, populateDropzone }:any = useConditional()

  const { currentConditional }:any = useConditionalCtx()

  // useEffect(() => {
  //   console.log(conditionalState.zones)
  // },[conditionalState.zones])


  return (
    <div className="w-full h-[13rem] flex flex-col gap-2">
      { currentConditional?.zones.map( (zone:any, idx:number) => (
        <ConditionalRow key={`${zone.zoneref}-${idx}`} row={zone} />
      ))}

      <ConditionalRow row={{ zoneref: "000", groups: [] }} />
    </div>
  )

}